module.exports = __webpack_public_path__ + "img/logo-composition.4b17a5d5.png";